import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICallResult } from "../callresultModel";

export const getAllCallResult = createAsyncThunk(
  "CallResult/FindAllCallResult",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/FindAllCallResult`,
        {
          call_result: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCallResult = createAsyncThunk(
  "CallResult/FindAllActiveCallResult",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CallResult/FindAllActiveCallResult`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CallResult:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCallResult = createAsyncThunk(
  "CallResult/InsertCallResult",
  async (CallResultData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/InsertCallResult`,
        CallResultData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CallResult:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCallResult = createAsyncThunk(
  "CallResult/UpdateCallResult",
  async (CallResultData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/UpdateCallResult`,
        CallResultData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CallResult:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCallResultByID = createAsyncThunk(
  "CallResult/FindByIDCallResult",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/FindByIDCallResult`,
        { call_result_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        call_result_guid: result.call_result_guid,
        call_result: result.call_result,
        isactive: result.isactive === true ? 1 : 2,
      } as ICallResult;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CallResult:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const CallResultActiveInactive = createAsyncThunk(
  "CallResult/ActiveInActiveCallResult",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/ActiveInActiveCallResult`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CallResult:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCallResult = createAsyncThunk(
  "CallResult/DeleteCallResult",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallResult/DeleteCallResult`,
        { call_result_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting typeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
